export class GroupDto {
  id: number;
  name: string;
}
